import { Injectable } from '@angular/core';
import {BaseService} from './base-service';

@Injectable({
  providedIn: 'root'
})
export class BaseUserService extends BaseService {

  constructor() {
    super();
  }

  /**
   * For easy override for user data such as users, groups, permissions, etc.
   */
  protected getGateway(): string {
    return super.getGateway();
  }
}
